var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"c-topic-list"},_vm._l((_vm.topics),function(topic){return _c('TopicCard',{key:topic.id,staticClass:"topic-item",attrs:{"topic":topic}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }